module.exports = __webpack_public_path__ + "assets/b26ee35af106b866b177e683779d7adb.mp3";